import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const SettingsSection = ({ title, description, icon, children, collapsible = false, defaultOpen = true }) => {
  const [isOpen, setIsOpen] = React.useState(defaultOpen);

  const handleToggle = () => {
    if (collapsible) {
      setIsOpen(!isOpen);
    }
  };

  return (
    <div className="bg-card rounded-xl border border-border shadow-therapeutic overflow-hidden">
      <button
        onClick={handleToggle}
        disabled={!collapsible}
        className={`
          w-full flex items-center justify-between p-4 sm:p-6
          ${collapsible ? 'cursor-pointer hover:bg-muted/50 transition-smooth' : 'cursor-default'}
          focus:outline-none focus:ring-3 focus:ring-ring focus:ring-inset
        `}
        aria-expanded={collapsible ? isOpen : undefined}
      >
        <div className="flex items-start gap-3 sm:gap-4 flex-1 text-left">
          <div className="flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-primary/10 flex-shrink-0">
            <Icon name={icon} size={20} color="var(--color-primary)" strokeWidth={2} />
          </div>
          <div className="flex-1 min-w-0">
            <h2 className="text-lg sm:text-xl font-heading font-semibold text-foreground mb-1">
              {title}
            </h2>
            {description && (
              <p className="text-sm sm:text-base text-muted-foreground">
                {description}
              </p>
            )}
          </div>
        </div>
        {collapsible && (
          <Icon 
            name={isOpen ? "ChevronUp" : "ChevronDown"} 
            size={20} 
            className="text-muted-foreground flex-shrink-0 ml-2 transition-smooth"
            strokeWidth={2}
          />
        )}
      </button>
      
      {(!collapsible || isOpen) && (
        <div className="px-4 pb-4 sm:px-6 sm:pb-6 pt-0 space-y-4">
          {children}
        </div>
      )}
    </div>
  );
};

export default SettingsSection;